import React, { useState, useEffect } from "react";
import Invoice from "./invoice";
import AuthUser from "./AuthUser";

export default function InvoiceModal({ show, onClose, taskId }) {
  const { http } = AuthUser();
  const [taskData, setTaskData] = useState(null);
  
  useEffect(() => {
    if (show && taskId) {
      fetchTaskData();
    }
  }, [show, taskId]);

  const fetchTaskData = async () => {
    try {
      const response = await http.get(`/task_invoice_data?id=${taskId}`);
      if (response.data.data) {
        setTaskData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching task data:", error);
    }
  };

  if (!show) return null;

  const handlePrint = () => {
    const printWindow = window.open('', '_blank');
    const invoiceElement = document.getElementById('invoice-content');
    
    if (invoiceElement && printWindow) {
      // Get all styles from the current document
      const styles = Array.from(document.styleSheets)
        .map(styleSheet => {
          try {
            return Array.from(styleSheet.cssRules)
              .map(rule => rule.cssText)
              .join('\n');
          } catch (e) {
            return '';
          }
        })
        .join('\n');

      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>${taskData?.job_card_number ? `Job ID: ${taskData.job_card_number}` : "Invoice"}</title>
          <meta charset="utf-8">
          <style>
            ${styles}
            body { 
              margin: 0; 
              padding: 0; 
              font-family: Arial, sans-serif;
              box-sizing: border-box;
            }
            .no-print { 
              display: none !important; 
            }
            * {
              box-sizing: border-box !important;
            }
          </style>
        </head>
        <body>
          ${invoiceElement.innerHTML}
        </body>
        </html>
      `);
      printWindow.document.close();
      
      // Wait for content to load before printing
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);
    }
  };

  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{taskData?.job_card_number ? `🆔 Job ID: ${taskData.job_card_number}` : "📋 Invoice"}</h5>
            <div className="d-flex gap-2">
              <button 
                className="btn btn-primary btn-sm"
                onClick={handlePrint}
              >
                🖨️ Print
              </button>
              <button 
                type="button" 
                className="btn-close" 
                onClick={onClose}
                aria-label="Close"
              ></button>
            </div>
          </div>
          <div className="modal-body p-0" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
            <div id="invoice-content">
              <Invoice taskId={taskId} taskData={taskData} hideControls={true} />
            </div>
          </div>
          <div className="modal-footer">
            <button 
              type="button" 
              className="btn btn-secondary" 
              onClick={onClose}
            >
              Close
            </button>
            <button 
              type="button" 
              className="btn btn-primary"
              onClick={handlePrint}
            >
              🖨️ Print Invoice
            </button>
          </div>
        </div>
      </div>
    </div>
  );
} 